module.exports = __webpack_public_path__ + "static/media/03-cedia.cee70be2.png";